import { render, staticRenderFns } from "./ReceivableBusinessInfo.vue?vue&type=template&id=841824f4"
import script from "./ReceivableBusinessInfo.vue?vue&type=script&lang=js"
export * from "./ReceivableBusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports